import { DrawCover, DrawPage1, DrawPage2 } from "./drawings";

/** Decorative sample-book illustration used on the landing hero and sign-in screen. */
export function StaticBookIllustration() {
  return (
    <div style={{ position: "relative", height: 180, margin: "12px 0", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ position: "absolute", width: 110, height: 140, transform: "translate(-46px, 6px) rotate(-9deg)" }}>
        <div className="tp-page-sheet" style={{ width: "100%", height: "100%" }}><DrawPage1 /></div>
      </div>
      <div style={{ position: "absolute", width: 110, height: 140, transform: "translate(46px, -2px) rotate(7deg)" }}>
        <div className="tp-page-sheet" style={{ width: "100%", height: "100%" }}><DrawPage2 /></div>
      </div>
      <div style={{ position: "absolute", width: 120, height: 150, transform: "translateY(-8px) rotate(-1deg)" }}>
        <div className="tp-page-sheet" style={{ width: "100%", height: "100%" }}><DrawCover /></div>
      </div>
    </div>
  );
}
